import {useEffect, useState} from 'react'
import '../../styles/bitacora.style.css'
import {useDispatch, useSelector} from 'react-redux'
import { State } from '../../../../reducers'
import BasicCardWithButtons from '../../../../components/BasicCardWithButtons'
import { PaginationStatic } from '../../../../components/PaginationStatic'
import { getDataConsultaDocsVenta, postGenerarLibroVentas, setTableVentasPaginaActual, setVentasIncluirRetenciones } from '../../../../actions/libros/libros-ventas.actions'
import { ItemLibroCF, ItemLibroContribuyente } from '../../../../interfaces/libros.interface'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import { optionsLibroVentas } from './FormularioLibroVentas'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import ModalRetencionesDetectadas from './ModalRetencionesDetectadas'

const TableVentasDocumentos = () => {
  const {formConsultaVentas, dataConsultaVentas, tableVentasTotalPages, tableVentasPageActual, ventasRetencionesDetectadas, ventasIncluirRetenciones} = useSelector((state: State) => state.libros);
  const [modalConfirmLibro, setModalConfirmLibro] = useState<boolean> (false);
  const [modalDetalleRetenciones, setModalDetalleRetenciones] = useState<boolean> (false);
  const hayRetenciones = formConsultaVentas?.tipoLibro === "02" && ventasRetencionesDetectadas.length > 0;
  const totalRetenido = ventasRetencionesDetectadas.reduce((total: number, item: any) => total + (parseFloat(item.ivaretenido) || 0), 0).toFixed(2);
  const dispatch = useDispatch();
  
  const handlePaginacion = async (page: number) => {
    const numberPage = page;
    const itemsPage = dataConsultaVentas.filter((fact:any) => fact?.pagina === numberPage);
    // Ver si ya han sido cargados los datos de la pagina
    if (itemsPage.length === 0) {
      // Datos aun no cargados
      await dispatch(getDataConsultaDocsVenta(formConsultaVentas, numberPage));
    }
    dispatch(setTableVentasPaginaActual(numberPage));
  }

  const handleGenerarLibro = async () => {
    if (await dispatch(postGenerarLibroVentas())) {
      setModalConfirmLibro(false);
    }
  }

  return (
    <div className="w-layout-layout bill-section wf-layout-layout">
      {
        modalConfirmLibro 
        && <ModalConfirm 
            title={"Confirmación"} 
            detail={`Se procede a generar el libro de IVA para el tipo de documento "${optionsLibroVentas.find(item => item.codigo === formConsultaVentas.tipoLibro)?.codigo_nombre}".${hayRetenciones && ventasIncluirRetenciones ? ` Se incluirán ${ventasRetencionesDetectadas.length} retenciones del 1% por $${totalRetenido}.` : ''} ¿Está seguro de que quiere realizar esta acción?`} 
            actionConfirm={handleGenerarLibro} 
            closeModalConfirm={() => setModalConfirmLibro(false)} 
          />
      }
      {
        modalDetalleRetenciones
        && <ModalRetencionesDetectadas items={ventasRetencionesDetectadas} onClose={() => setModalDetalleRetenciones(false)} />
      }
      <BasicCardWithButtons 
        style={{boxShadow: 'none', padding: '0'}} 
        title="Documentos" 
        size="l" 
        buttons={<ButtonsCardDetalle onOpenGenerar={() => setModalConfirmLibro(true)} />}
      >
        {
          hayRetenciones
          && <div style={{display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', padding: '12px 16px', marginBottom: '16px', border: '1px solid #d0d5dd', borderRadius: '8px', textAlign: 'left'}}>
              <label style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', flex: '1 1 320px'}}>
                <input
                  type="checkbox"
                  checked={ventasIncluirRetenciones}
                  onChange={(e) => dispatch(setVentasIncluirRetenciones(e.target.checked))}
                />
                <span className="m">
                  Se detectaron <b>{ventasRetencionesDetectadas.length}</b> CCF con retención del 1% (IVA retenido <b>${totalRetenido}</b>) sin comprobante cargado.
                  Incluirlas en el libro al generarlo.
                </span>
              </label>
              <button className="button w-auto transparent" onClick={() => setModalDetalleRetenciones(true)}>Ver detalle</button>
            </div>
        }
        <div className="tab-plane">
          <div className="table-facturacion-resp">
            {
              formConsultaVentas?.tipoLibro === "01" ? <TableVentaCF data={dataConsultaVentas} pageActual={tableVentasPageActual} /> : <TableVentaContribuyentes data={dataConsultaVentas} pageActual={tableVentasPageActual} />
            }
          </div>
          <PaginationStatic 
            pagesDefault={tableVentasTotalPages}
            onChangeCurrentPage={handlePaginacion} 
            items={20} 
          />
        </div>
      </BasicCardWithButtons>
    </div>
  )
}

export const TableVentaCF = (props: any) => {
  const {data, pageActual} = props;
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);

  useEffect(() => {
    setSortedArray(data);
  }, [data]);

  return (
    <table className="table-main-responsive responsive-table-main td-left table-pointer">
      <thead>
        <tr>
          <td>No. de correlativo <FilterButton keyName='nocorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Tipo DTE <FilterButton keyName='valor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Fecha de emisión <FilterButton keyName='dia' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Serie <FilterButton keyName='serie' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Del <FilterButton keyName='del' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Hasta <FilterButton keyName='hasta' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total gravada <FilterButton keyName='gravada' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total exenta <FilterButton keyName='exenta' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total no sujeta <FilterButton keyName='nosujeta' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total venta <FilterButton keyName='totalventa' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
        </tr>
      </thead>
      <tbody>
        {
          sortedArray.length > 0 && 
          (
            sortedArray?.filter((item:ItemLibroCF) => item.pagina === pageActual)?.map((item: ItemLibroCF) => (
              <tr key={item.nocorrelativo}>
                <td data-label="No. de correlativo">{item.nocorrelativo}</td>
                <td data-label="Tipo DTE">{item.valor}</td>
                <td data-label="Fecha de emisión">{item.dia}</td>
                <td data-label="Serie">{item.serie}</td>
                <td data-label="Del">{item.del}</td>
                <td data-label="Hasta">{item.hasta}</td>
                <td data-label="Total gravada">{item.gravada || "--"}</td>
                <td data-label="Total exenta">{item.exenta || "--"}</td>
                <td data-label="Total no sujeta">{item.nosujeta || "--"}</td>
                <td data-label="Total venta">{item.totalventa || "--"}</td>
              </tr>
            )) 
          )
        }
      </tbody>
  </table>
  )
}

export const TableVentaContribuyentes = (props: any) => {
  const {data, pageActual} = props;
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);

  useEffect(() => {
    setSortedArray(data);
  }, [data]);

  return (
    <table className="table-main-responsive responsive-table-main td-left table-pointer">
      <thead>
        <tr>
          <td>No. de Correlativo <FilterButton keyName='nocorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Tipo DTE <FilterButton keyName='nombredte' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Fecha de emisión <FilterButton keyName='dia' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Serie <FilterButton keyName='serie' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Número de documento <FilterButton keyName='numfactura' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Receptor <FilterButton keyName='receptornombre' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Receptor NIT <FilterButton keyName='receptornumdocto' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Receptor NRC <FilterButton keyName='receptornrc' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total gravada <FilterButton keyName='gravada' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total exente <FilterButton keyName='exenta' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total no sujeta <FilterButton keyName='nosujeta' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total venta <FilterButton keyName='totalventa' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Total IVA <FilterButton keyName='totaliva' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>Comprobante retención <FilterButton keyName='comprobanteretencion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
          <td>IVA Retenido <FilterButton keyName='ivaretenido' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
        </tr>
      </thead>
      <tbody>
        {
          sortedArray.length > 0 && 
          (
            sortedArray?.filter((item:ItemLibroCF) => item.pagina === pageActual)?.map((item: ItemLibroContribuyente) => (
              <tr key={item.nocorrelativo}>
                <td data-label="No. de Correlativo">{item.nocorrelativo}</td>
                <td data-label="Tipo DTE">{item.nombredte}</td>
                <td data-label="Fecha de emisión">{item.dia}</td>
                <td data-label="Serie">{item.serie}</td>
                <td data-label="Número de documento">{item.numfactura}</td>
                <td data-label="Receptor">{item.receptornombre}</td>
                <td data-label="Receptor Documento">{item.receptornumdocto}</td>
                <td data-label="Receptor NRC">{item.receptornrc}</td>
                <td data-label="Total gravada">{item.gravada || "--"}</td>
                <td data-label="Total exente">{item.exenta || "--"}</td>
                <td data-label="Total no sujeta">{item.nosujeta || "--"}</td>
                <td data-label="Total venta">{item.totalventa || "--"}</td>
                <td data-label="Total IVA">{item.totaliva || "--"}</td>
                <td data-label="Comprobante retención">{item.comprobanteretencion || "--"}</td>
                <td data-label="IVA Retenido">{item.ivaretenido || "--"}</td>
              </tr>
            )) 
          )
        }
      </tbody>
  </table>
  )
}

export const ButtonsCardDetalle = ({onOpenGenerar}: {onOpenGenerar: any}) => {
  return (
    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
      <button className="button w-auto" onClick={onOpenGenerar}>Generar libro de IVA</button>
    </div>
  )
}

export default TableVentasDocumentos
